module.exports = __webpack_public_path__ + "img/BrowseDataPoints.cf03a747.svg";